<script>
  import {preview} from '@/store';
  import MusicOptions from './MusicOptions.svelte';
  import MusicSelect from './MusicSelect.svelte';
</script>

<div class="w-full">
  <div class="grid w-full gap-2">
    <h1 class="text-sm font-bold" id="sb-music">Music</h1>
    <div class="w-full">
      <MusicSelect />
    </div>
  </div>
  {#if $preview.music !== null}
    <div class="w-full">
      <MusicOptions />
    </div>
  {/if}
</div>
